<template>
  <svg
    :class="['w-5 h-5 text-gray-500', className] | twMerge"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1838_193231)">
      <path
        d="M0.247931 1.9394L7.50713 11.5152V16.3636L12.4929 20V11.5152L19.7521 1.9394C19.8904 1.75899 19.9746 1.5444 19.9951 1.31978C20.0156 1.09515 19.9716 0.869387 19.868 0.667879C19.7645 0.46637 19.6055 0.297107 19.4089 0.179121C19.2124 0.0611348 18.986 -0.000893703 18.7554 9.72964e-06H1.24458C1.01395 -0.000893703 0.787634 0.0611348 0.591081 0.179121C0.394529 0.297107 0.235535 0.46637 0.13198 0.667879C0.0284254 0.869387 -0.0155845 1.09515 0.00489945 1.31978C0.0253834 1.5444 0.109549 1.75899 0.247931 1.9394Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_1838_193231">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'FilterFilled',
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>